import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api`);

export const getComments = async (ticketId) => {
  const response = await API.get(`/tickets/${ticketId}/comments`);
  return response.data;
};

export const createComment = async (ticketId, data) => {
  const response = await API.post(`/tickets/${ticketId}/comments`, data);
  return response.data;
};

export const deleteComment = async (commentId) => {
  const response = await API.delete(`/comments/${commentId}`);
  return response.data;
};
